import { render } from "./MobileTransactionListItem.vue?vue&type=template&id=48be2c22"
import script from "./MobileTransactionListItem.vue?vue&type=script&lang=ts"
export * from "./MobileTransactionListItem.vue?vue&type=script&lang=ts"
script.render = render

export default script